import './scss/main.scss'
import '@zoom/common-header/style.css'
import { create } from './js/utilities/module-loader'
import { initHashLinks } from './js/utilities/hash-links'
import { initCommonHeader } from './js/utilities/common-header-waffle'
import { initCommonHeaderMenus } from './js/utilities/common-header-menus'
import { initSegmentPreference } from './js/utilities/segment-preference'
import LazyImageLoader from './js/utilities/lazy-loading'
import { initVisitorGuidSync } from './js/utilities/visitor-guid-sync'
import { moduleMap } from './module-map'

/**
 * Zoom App responsible for loading modules on page load
 */
export default class App {
  constructor() {
    this.modules = [] // ref to all of the instantiated module
    this.lazyImageLoader = new LazyImageLoader()
    this.loadModules()
  }

  /**
   * Destroys all modules in the app
   */
  destroy() {
    this.lazyImageLoader?.destroy()
    this.modules.forEach((module) => {
      if (typeof module.destroy === 'function') {
        module.destroy()
      }
    })
  }

  /**
   * Queries the DOM elements modules on a page and instantiates
   * an instance of them if they have not yet been instantiated
   * and the associated JS module is defined
   */
  loadModules() {
    initHashLinks()
    initCommonHeader()
    initCommonHeaderMenus()
    initSegmentPreference()
    initVisitorGuidSync()
    this.lazyImageLoader.init()
    if (
      document.readyState === 'complete' ||
      document.readyState === 'loaded' ||
      document.readyState === 'interactive'
    ) {
      create(moduleMap).then((modules) => {
        this.modules.push(modules)
      })
    }
    document.addEventListener('DOMContentLoaded', () => {
      create(moduleMap).then((modules) => {
        this.modules.push(modules)
      })
    })
  }
}
